
function hideKeyboard(){
  const activeElement = document.activeElement;
  activeElement.blur();
}
export {hideKeyboard};
